// extracted by mini-css-extract-plugin
module.exports = {"MenuSectionTitle":"MenuSectionTitle_MenuSectionTitle__2-77T","WhiteDash":"MenuSectionTitle_WhiteDash__1vgGN","Title":"MenuSectionTitle_Title__24Ij8"};